module.exports = __webpack_public_path__ + "favicon/favicon.ico";